var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58548 0.297852C4.00567 0.297852 0.289062 4.05753 0.289062 8.69042C0.289062 13.3233 4.00567 17.083 8.58548 17.083C13.1653 17.083 16.8819 13.3233 16.8819 8.69042C16.8579 4.05753 13.1653 0.322108 8.58548 0.297852ZM8.58548 16.3553C4.4133 16.3553 1.00841 12.911 1.00841 8.69042C1.00841 4.46988 4.4133 1.02553 8.58548 1.02553C12.7577 1.02553 16.1626 4.46988 16.1626 8.69042C16.1386 12.911 12.7577 16.3311 8.58548 16.3553Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 2.99023L6.71464 8.69039L4.125 14.3906L14.1239 8.69039L4.125 2.99023ZM5.70755 4.73667L12.0138 8.32655H7.33807L5.70755 4.73667ZM7.33807 9.05423H12.0138L5.70755 12.6441L7.33807 9.05423Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendFeedback);
export default __webpack_public_path__ + "static/media/send-feedback.e2111bf1ba57055942da788747e9914e.svg";
export { ForwardRef as ReactComponent };